import { supabase } from './supabase';

// Server-side AI-proxy. De OpenRouter-key hoort niet in een publieke Vite-bundle
// (incident 11-06-2026): voorheen riep de browser rechtstreeks OpenRouter aan met
// een gebakken key. Nu loopt elke AI-call via de Jarvis-backend (/ai/complete),
// geauthenticeerd met het Supabase access token van de ingelogde gebruiker.
const API_BASE = (import.meta.env.VITE_API_BASE as string) || '';
const TENANT_ID = (import.meta.env.VITE_WEBHOOK_TENANT_ID as string) || '2bmade';

export interface AiMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

export interface AiCompleteOptions {
  messages: AiMessage[];
  temperature?: number;
  max_tokens?: number;
  /** Vraag JSON-mode (response_format: json_object) aan. */
  json?: boolean;
}

export async function aiComplete(opts: AiCompleteOptions): Promise<string> {
  if (!API_BASE) {
    throw new Error('AI niet geconfigureerd: VITE_API_BASE ontbreekt in build-env.');
  }

  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('Geen actieve sessie. Log opnieuw in en probeer het nog eens.');
  }

  const body = {
    data: {
      messages: opts.messages,
      ...(opts.temperature !== undefined ? { temperature: opts.temperature } : {}),
      ...(opts.max_tokens !== undefined ? { max_tokens: opts.max_tokens } : {}),
      ...(opts.json ? { response_format: { type: 'json_object' } } : {}),
    },
    tenant_id: TENANT_ID,
  };

  const response = await fetch(`${API_BASE}/ai/complete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`AI-call faalde: ${response.status} ${text.slice(0, 200)}`);
  }

  const json = (await response.json()) as { content?: string };
  const content = json.content;
  if (!content) throw new Error('AI gaf geen content terug');
  return content;
}
